import { useCallback, useEffect, useState } from 'react';
import { getVideoMetadata } from 'services/media';

import { getImageResolution as getResolutionFromImage } from '../utilities';

export const getContentResolution = (src?: string, mediaType?: 'image' | 'video') => {
  const [value, setValue] = useState<{ width: number; height: number }>();

  const getResolution = useCallback(async () => {
    if (!src) return;
    if (mediaType === 'video') {
      const videoMetadata = await getVideoMetadata(src);
      setValue({ width: videoMetadata.width, height: videoMetadata.height });
    } else {
      const resolution = await getResolutionFromImage(src);
      setValue({ width: resolution.width, height: resolution.height });
    }
  }, [src, mediaType]);

  useEffect(() => {
    getResolution();
  }, [getResolution]);

  return value;
};
